import { SVGProps } from "react";

const Checkmark = ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.007 1.10328C7.60544 0.64957 6.08181 1.28067 5.41156 2.59257L4.60578 4.16974C4.51004 4.35714 4.35763 4.50955 4.17023 4.60529L2.59306 5.41107C1.28116 6.08132 0.650058 7.60495 1.10377 9.00651L1.64923 10.6915C1.71404 10.8917 1.71404 11.1073 1.64923 11.3075L1.10377 12.9925C0.650058 14.3941 1.28116 15.9177 2.59306 16.588L4.17023 17.3937C4.35763 17.4895 4.51004 17.6419 4.60578 17.8293L5.41156 19.4065C6.08181 20.7184 7.60544 21.3495 9.007 20.8958L10.692 20.3503C10.8922 20.2855 11.1078 20.2855 11.308 20.3503L12.993 20.8958C14.3946 21.3495 15.9182 20.7184 16.5885 19.4065L17.3942 17.8293C17.49 17.6419 17.6424 17.4895 17.8298 17.3937L19.407 16.588C20.7189 15.9177 21.35 14.3941 20.8963 12.9925L20.3508 11.3075C20.286 11.1073 20.286 10.8917 20.3508 10.6915L20.8963 9.00651C21.35 7.60495 20.7189 6.08132 19.407 5.41107L17.8298 4.60529C17.6424 4.50955 17.49 4.35714 17.3942 4.16974L16.5885 2.59257C15.9182 1.28067 14.3946 0.64957 12.993 1.10328L11.308 1.64874C11.1078 1.71354 10.8922 1.71355 10.692 1.64874L9.007 1.10328ZM5.75977 10.7568L7.17399 9.34251L10.0024 12.171L15.6593 6.51416L17.0735 7.92837L10.0024 14.9994L5.75977 10.7568Z"
            fill="#0EAA15"
        />
    </svg>
);

export default Checkmark;
